import React from "react";
import {
  SideMenuContainer,
  TitleSection,
  TitleText,
  AppIcon,
  MenuOptionList,
  MenuOption,
  MenuOptionImage,
  MenuOptionText,
} from "./styles";
import AppIconSVG from "../../../../resources/logo.png";
import { MenuOptions } from "./config";
import { useHistory } from "react-router";
import ReactGA from "react-ga";

function SideMenu({ currentOption }) {
  let history = useHistory();
  return (
    <SideMenuContainer>
      <TitleSection
        onClick={() => {
          ReactGA.event({
            category: "App - Menu",
            action: "Clicked on Logo",
          });
          history.push("/");
        }}
      >
        <AppIcon src={AppIconSVG} />
        <TitleText>MarketSentiment</TitleText>
      </TitleSection>
      <MenuOptionList>
        {Object.keys(MenuOptions).map((option, index) => {
          return (
            <MenuOption
              key={index}
              active={currentOption === option}
              onClick={() => {
                ReactGA.event({
                  category: "App - Menu",
                  action: "Navigated to " + MenuOptions[option].text,
                });
                if (MenuOptions[option].text === "Blog") {
                  window.location.href = MenuOptions[option].url;
                } else {
                  ReactGA.pageview(MenuOptions[option].url);
                  history.push(MenuOptions[option].url);
                }
              }}
            >
              <MenuOptionImage>{MenuOptions[option].icon}</MenuOptionImage>
              <MenuOptionText>{MenuOptions[option].text}</MenuOptionText>
            </MenuOption>
          );
        })}
      </MenuOptionList>
    </SideMenuContainer>
  );
}
export default SideMenu;
